import { render, staticRenderFns } from "./TutorialMatchingUpload.vue?vue&type=template&id=7d89c20d&scoped=true&"
import script from "./TutorialMatchingUpload.vue?vue&type=script&lang=js&"
export * from "./TutorialMatchingUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d89c20d",
  null
  
)

export default component.exports